"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.apiServices = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = require("lodash");

var _sprintfJs = require("sprintf-js");

var _uuid = require("uuid");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ApiServices = /*#__PURE__*/function () {
  function ApiServices() {
    (0, _classCallCheck2["default"])(this, ApiServices);
    this.services = {};
  }

  (0, _createClass2["default"])(ApiServices, [{
    key: "register",
    value: function register(api) {
      var apiReference = (0, _uuid.v4)();
      this.services[apiReference] = api;
      return apiReference;
    }
  }, {
    key: "getApi",
    value: function getApi(apiReference) {
      return this.services[apiReference];
    }
  }, {
    key: "getEndpoint",
    value: function getEndpoint(_ref) {
      var apiReference = _ref.apiReference,
          endpointName = _ref.endpointName;
      return this.getApi(apiReference)[endpointName];
    }
  }]);
  return ApiServices;
}();

var apiServices = new ApiServices();
exports.apiServices = apiServices;

var Api = /*#__PURE__*/function () {
  function Api(_ref2) {
    var baseUrl = _ref2.baseUrl,
        _ref2$version = _ref2.version,
        version = _ref2$version === void 0 ? "" : _ref2$version,
        _ref2$apiSettings = _ref2.apiSettings,
        apiSettings = _ref2$apiSettings === void 0 ? {} : _ref2$apiSettings;
    (0, _classCallCheck2["default"])(this, Api);
    this.endpointNames = [];
    this.token = null;
    this.guestToken = null;
    this.apiReference = apiServices.register(this);
    this.apiSettings = apiSettings;
    this.version = version;

    this.baseUrl = function () {
      if (!baseUrl) {
        var error = new Error("SPQ Redux Api Client: Api must be initialized with a baseUrl");
        throw error;
      }

      var base = baseUrl.toString();

      if (base.substr(-1) !== "/") {
        return "".concat(base, "/");
      }

      return base;
    }();
  }
  /* To be overwritten by user if needed */


  (0, _createClass2["default"])(Api, [{
    key: "retrieveErrorMessage",
    value: function retrieveErrorMessage(error) {
      try {
        if (error.message) {
          return error.message;
        }

        if (error.error) {
          if (error.error.message) {
            return error.error.message;
          }

          return error.error;
        }

        if (error.err) {
          return error.err;
        }

        if (error.msg) {
          if (Object.keys(error.msg).length === 1) {
            if (Object.keys(error.msg)[0].length === 1) {
              return Object.values(error.msg)[0][0];
            }

            return Object.values(error.msg)[0];
          }
        }

        if (error.detail) {
          return error.detail;
        }

        return "Undefined error message";
      } catch (e) {
        return "Undefined error message";
      }
    }
    /* To be overwritten by user if needed */

  }, {
    key: "parseErrorCode",
    value: function parseErrorCode(error) {
      if (error.error && error.error.code) {
        return error.error.code;
      }

      if (error.error && error.error.Code) {
        return error.error.Code;
      }

      if (error.code) {
        return error.code;
      }

      if (error.Code) {
        return error.Code;
      }

      return null;
    }
    /* To be overwritten by user if needed */

  }, {
    key: "replaceErrorMessage",
    value: function replaceErrorMessage(message) {
      return message;
    }
  }, {
    key: "parseErrorMessage",
    value: function parseErrorMessage(error) {
      return this.replaceErrorMessage(this.retrieveErrorMessage(error));
    }
  }, {
    key: "parseErrorObject",
    value: function parseErrorObject(error) {
      return {
        success: false,
        message: this.parseErrorMessage(error),
        code: this.parseErrorCode(error),
        data: error
      };
    }
  }, {
    key: "constructEndpoints",
    value: function constructEndpoints(Endpoint) {
      var _this = this;

      var properties = Object.entries(this);
      var endpointNames = [];
      properties.filter(function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            value = _ref4[1];

        return value instanceof Endpoint;
      }).forEach(function (_ref5) {
        var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
            endpointName = _ref6[0],
            endpoint = _ref6[1];

        endpoint.initialize(_this, endpointName);
        endpointNames.push(endpointName);
      });
      this.endpointNames = endpointNames;
    }
  }, {
    key: "setToken",
    value: function setToken() {
      var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.token = token;
    }
  }, {
    key: "setGuestToken",
    value: function setGuestToken() {
      var guestToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.guestToken = guestToken;
    }
  }, {
    key: "constructURL",
    value: function constructURL(endpoint) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var searchParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Building path params if any
      var url = new URL((0, _sprintfJs.vsprintf)(endpoint, args), this.baseUrl); // Building search params if any

      if ((0, _lodash.isPlainObject)(searchParams)) {
        Object.entries(searchParams).forEach(function (_ref7) {
          var _ref8 = (0, _slicedToArray2["default"])(_ref7, 2),
              key = _ref8[0],
              value = _ref8[1];

          if (Array.isArray(value)) {
            value.forEach(function (param) {
              if (param != null) {
                // Append the value if it is an array
                url.searchParams.append(key, param);
              }
            });
            return;
          }

          if (value != null) {
            url.searchParams.set(key, value);
          }
        });
      }

      return url;
    }
  }, {
    key: "prepareRequestOptions",
    value: function prepareRequestOptions(_ref9) {
      var body = _ref9.body,
          _ref9$token = _ref9.token,
          token = _ref9$token === void 0 ? null : _ref9$token,
          _ref9$guestToken = _ref9.guestToken,
          guestToken = _ref9$guestToken === void 0 ? null : _ref9$guestToken,
          otherOptions = (0, _objectWithoutProperties2["default"])(_ref9, ["body", "token", "guestToken"]);
      var headers = new Headers(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, token && {
        Authorization: "Token ".concat(token)
      }), guestToken && {
        Authorization: "GuestToken ".concat(guestToken)
      }), body && {
        "Content-Type": "application/json"
      }), {}, {
        Accept: "application/json"
      }));
      return _objectSpread({
        headers: headers,
        body: body && JSON.stringify(body)
      }, otherOptions);
    }
  }, {
    key: "parseResponse",
    value: function parseResponse(responseText) {
      try {
        return JSON.parse(responseText);
      } catch (error) {
        return responseText;
      }
    }
    /* To be overwritten by user if needed */

  }, {
    key: "logRequest",
    value: function logRequest(endpoint, url, options) {}
    /* To be overwritten by user if needed */

  }, {
    key: "logError",
    value: function logError(endpoint, url, options, response) {
      var message = "Failed ".concat(options.method || "GET", " request: ").concat(url);
      console.error("Redux API Client Error: ".concat(message));
    }
    /* Can be overwritten by user to set custom success criteria */

  }, {
    key: "checkSuccess",
    value: function checkSuccess(_ref10) {
      var response = _ref10.response,
          responseData = _ref10.responseData;
      return response.ok === true || response.status === 204 || (0, _lodash.isObject)(responseData) && responseData.success !== false && responseData.success !== undefined;
    }
  }, {
    key: "responseTransformation",
    value: function responseTransformation(response) {
      return response;
    }
  }, {
    key: "sendRequest",
    value: function () {
      var _sendRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(endpointUrl, options, endpoint) {
        var overrideOptions,
            urlArgs,
            searchParams,
            requestOptions,
            url,
            preparedRequestOptions,
            response,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                overrideOptions = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                urlArgs = options.urlArgs, searchParams = options.searchParams, requestOptions = (0, _objectWithoutProperties2["default"])(options, ["urlArgs", "searchParams"]);
                url = this.constructURL(endpointUrl, urlArgs, searchParams);
                preparedRequestOptions = endpoint.prepareRequestOptions(_objectSpread(_objectSpread({}, requestOptions), overrideOptions));
                this.logRequest(endpoint, url, preparedRequestOptions);
                _context.next = 7;
                return this.executeRequest(url, preparedRequestOptions);

              case 7:
                response = _context.sent;

                if (response.error) {
                  this.logError(endpoint, url, options, response);
                }

                return _context.abrupt("return", response);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendRequest(_x, _x2, _x3) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }, {
    key: "executeRequest",
    value: function () {
      var _executeRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url, options) {
        var response, hasGuestToken, responseText, responseData, isSuccess, _response;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch(url, _objectSpread({}, options));

              case 3:
                response = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  error: {
                    success: false,
                    message: _context2.t0.message || "Undefined error"
                  }
                });

              case 9:
                hasGuestToken = null; // extract custom guest token from response header of place order endpoint

                if (response.headers.get('x-guesttoken')) {
                  hasGuestToken = {
                    "x-guesttoken": response.headers.get('x-guesttoken')
                  };
                }

                _context2.next = 13;
                return response.text();

              case 13:
                responseText = _context2.sent;
                responseData = this.parseResponse(responseText);
                isSuccess = this.checkSuccess({
                  response: response,
                  responseData: responseData
                });

                if (!isSuccess) {
                  _context2.next = 19;
                  break;
                }

                _response = this.responseTransformation(responseData);
                return _context2.abrupt("return", _objectSpread({
                  response: _response || {
                    success: true
                  }
                }, hasGuestToken && {
                  responseHeaders: hasGuestToken
                }));

              case 19:
                return _context2.abrupt("return", {
                  error: this.parseErrorObject(responseData)
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function executeRequest(_x4, _x5) {
        return _executeRequest.apply(this, arguments);
      }

      return executeRequest;
    }()
  }]);
  return Api;
}();

var _default = Api;
exports["default"] = _default;